var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "filter-selection-drop-down drop-down-overlay",
      class: _vm.filterContainerClasses,
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c(
        "a",
        {
          staticClass: "btn btn-close",
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.filterCloseButtonClick.apply(null, arguments)
            },
          },
        },
        [_vm._v("Close")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "view" },
        _vm._l(_vm.filterColumns, function (filterColumn, filterColumnIndex) {
          return _c(
            "ul",
            { key: filterColumnIndex },
            [
              _vm._l(filterColumn, function (filterType) {
                return [
                  _c(
                    "li",
                    {
                      staticClass: "title",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.titleClickHandler(filterType.key)
                        },
                      },
                    },
                    [_vm._v(_vm._s(filterType.title))]
                  ),
                  _vm._v(" "),
                  _vm._l(filterType.items, function (filterValue) {
                    return _c(
                      "li",
                      {
                        key: filterType.key + "::" + filterValue.value,
                        class: {
                          active: filterValue.selected,
                          show:
                            filterType.key in _vm.filterTypesToShow &&
                            _vm.filterTypesToShow[filterType.key],
                        },
                        attrs: {
                          "data-id": filterType.key,
                          "data-value": filterValue.value,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.filterClickHandler(
                              filterType.key,
                              filterValue.value,
                              !filterValue.selected
                            )
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "filter-checkbox" }, [
                          _c("svg", { staticClass: "checked" }, [
                            _c("use", {
                              attrs: {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href": "#ic_check_box_24px",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("svg", { staticClass: "unchecked" }, [
                            _c("use", {
                              attrs: {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href":
                                  "#ic_check_box_outline_blank_24px",
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(filterValue.title) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                ]
              }),
            ],
            2
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }